import styles from './PricingMarketingHook.module.scss';
import type { DcsEntities } from 'api/contentful/contentTypes.cloverdotcom';
import { useDCS } from 'hooks/useDCS';
import React, { FC } from 'react';
import { BundlePricing } from '../BundlePricing/BundlePricing';

interface IPricingMarketingHookProps {
  dcsEntities: DcsEntities;
}

export const PricingMarketingHook: FC<IPricingMarketingHookProps> = ({ dcsEntities }) => {
  const { bundlesPricings } = useDCS({ bundleIds: [dcsEntities.bundleId ?? ''] });

  const pricing = bundlesPricings[0];
  if (!pricing) return null;

  return (
    <div className={styles.pricing}>
      <BundlePricing pricing={pricing} showSoftwareMonthlyPlan={false} />
    </div>
  );
};
